/// <reference path="../../setup/_references.ts" />
module onvio.test {
    'use strict';

    export class HybridTestController {
        private data: string[];
        private gridData: any[];
        private flexGrid: any = null;
        private columnBindings: string[];
        private legacyData: { id: number, name: string }[];
        private legacyModel: string;
        private alertTypes: any[] = ['danger', 'warning', 'info', 'success'];
        private alerts: any[] = [];

        public isLoading = true;

        public client: cs.IClientWithExpansionV3Dto;
        public manager: cs.IEmployeeWithExpansionV3Dto;
        public partner: cs.IEmployeeWithExpansionV3Dto;
        public associate: cs.IEmployeeWithExpansionV3Dto;
        public billing: cs.IContactWithExpansionV6Dto;
        public preferred: cs.IContactWithExpansionV6Dto;
        public taxMatters: cs.IContactWithExpansionV6Dto;

        constructor() {
            this.data = this._generateData(25);
            this.legacyData = this._generateLegacyData();

            this.gridData = this.generateGridData(10);
            this.columnBindings = Object.keys(this.gridData[0]);
        }

        private _generateData(size: number = 5): any[] {
            const a = [];

            for (let i = 0; i < size; i++) {
                a.push('Label ' + i);
            }
            return a;
        }

        private _generateLegacyData(): any[] {
            const a = [];

            for (let i = 0; i < 25; i++) {
                a.push({ id: i, name: this.data[i] });
            }

            return a;
        }

        // Helper method to simulate dataset
        private getData() {
            return this.legacyData;
        }

        private getAlertType() {
            var index = Math.floor(Math.random() * 4);

            return this.alertTypes[index];
        }

        // Callback function when an alert is closed
        private closeAlert($index: number) {
            console.log('Alert #', $index, 'is being closed');
        }

        private addAlert() {
            var type = this.getAlertType();

            this.alerts.push({
                type: type,
                msg: 'Bento Modern ' + type + ' message, with a <a href=\"#/components/alerts\">relevant link</a>.',
                closeable: true
            });
        }

        private generateGridData(size: number): any[] {
            let data: any[] = [];
            for (let i = 0; i < size; i++) {
                let item = {
                    selected: false,
                    col1: 'Col1 Item ' + i,
                    col2: 'Col2 Item ' + i,
                    col3: 'Col3 Item ' + i
                };
                data.push(item);
            }

            return data;
        }
    }

    angular.module('onvio.test', [])
        .controller('HybridTestController', HybridTestController)
        .config(['$stateProvider', ($stateProvider: ng.ui.IStateProvider) => {
            $stateProvider.state('hybrid-playground', {
                url: '/hybrid-playground',
                templateUrl: 'views/test/hybrid-playground.html',
                controller: 'HybridTestController as $ctrl',
                resolve: {
                    permission: ['$state', 'bmLicense', ($state: ng.ui.IStateService, bmLicense: any) => {
                        bmLicense.has('Internal.Internal').then(() => {
                            angular.noop();
                        }).catch(() => {
                            $state.go('notfound', {}, { location: 'replace' });
                        });
                    }]
                }
            });
        }]);
}
